/**
 * 用户管理
 */
import { USERMANAGE } from '../types';

export default {
    name: `${USERMANAGE}`,
    path: '/userManage',
    component: () => import(/* webpackChunkName: 'userManage' */ '@/views/userManage/'),
    redirect: { name: `${USERMANAGE}Index` },
    meta: {
        title: '用户管理',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${USERMANAGE}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'userManage' */ '@/views/userManage/home/Home.vue'),
        },
    ],
};
